import { DefaultState } from 'store/reducers/types';

export const DOWNLOAD_COMMENT_REPORT_EXCEL_REQUEST = 'DOWNLOAD_COMMENT_REPORT_EXCEL_REQUEST';
export const DOWNLOAD_COMMENT_REPORT_EXCEL_SUCCESS = 'DOWNLOAD_COMMENT_REPORT_EXCEL_SUCCESS';
export const DOWNLOAD_COMMENT_REPORT_EXCEL_FAILURE = 'DOWNLOAD_COMMENT_REPORT_EXCEL_FAILURE';

export type CommentReportExcelState = DefaultState;

interface CommentReportExcelRequest {
  type: typeof DOWNLOAD_COMMENT_REPORT_EXCEL_REQUEST;
};

interface CommentReportExcelSuccess {
  type: typeof DOWNLOAD_COMMENT_REPORT_EXCEL_SUCCESS,
}

interface CommentReportExcelFailure {
  type: typeof DOWNLOAD_COMMENT_REPORT_EXCEL_FAILURE;
}

export type CommentReportExcelActionTypes = CommentReportExcelRequest | CommentReportExcelSuccess | CommentReportExcelFailure;